export default "__VITE_ASSET__CqyJTGTO__"